import { render, staticRenderFns } from "./OccurrenceAdd.vue?vue&type=template&id=67f1d92a&scoped=true"
import script from "./OccurrenceAdd.vue?vue&type=script&lang=js"
export * from "./OccurrenceAdd.vue?vue&type=script&lang=js"
import style0 from "./OccurrenceAdd.vue?vue&type=style&index=0&id=67f1d92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1d92a",
  null
  
)

export default component.exports